'use client';
import clsx from 'clsx';
import Image from 'next/image';
import React, { useState } from 'react';

import { ICasino } from '@/lib/dto';
import { getDataLocal, saveLocalByKey, setDataLocal } from '@/lib/utils';

import { openGameProvider } from '@/components/core/OpenGame';
import { useAppRouter } from '@/components/hooks/useAppRouter';
import CardHoloEffect from '@/components/hooks/useCardHolo';
import CounterUp from '@/components/modules/CounterUp';

import { useGameModalStore } from '@/store/zustand';

import { recentPlay } from '@/app/[lng]/(home)/components/Mobile/components/Renderer/RenderCateItemGames';

const ItemLive = (props: any) => {
  const item: ICasino = props?.item;
  const { router } = useAppRouter();
  const slotJackpotNumber = props?.slotJackpotNumber || 0;
  const [loaded, setLoaded] = useState(false);
  const { isLoadingGame } = useGameModalStore();
  const number = Number(slotJackpotNumber || 0);
  const end = Number(number || String(item?.id + '102321'));
  const start = end - 1000;

  return (
    <div
      className='relative'
      onClick={async () => {
        if (isLoadingGame !== 0 && isLoadingGame !== item.id) return;
        await openGameProvider(item, router);
        const threeDaysInMillis = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds
        saveLocalByKey({
          entryPointKey: recentPlay,
          cate: props.cate,
          currentItem: item,
          isRemoveable: false,
          onSavedData: () => {
            setDataLocal(recentPlay, {
              ...(getDataLocal(recentPlay) || {}),
              expiredTime: new Date().getTime() + threeDaysInMillis,
            });
          },
          isCheckSaveDuplicate: true,
        });
      }}
    >
      <CardHoloEffect animated={loaded} className='aspect-[1.45/1]'>
        <div
          className={clsx(
            `cursor-hand shadow-box-light flex flex-col rounded-lg transition-all`,
            !loaded && 'loading-bg',
            props?.className
          )}
        >
          <div className='shine-item relative h-full w-full'>
            {item?.image && (
              <Image
                loading='lazy'
                className={clsx(
                  'user h-full w-full select-none rounded-lg',
                  isLoadingGame === item.id && '!brightness-50'
                )}
                src={item?.image}
                width={225}
                height={168}
                alt={item?.name}
                // loading='lazy'
                onLoad={() => {
                  setLoaded(true);
                }}
              />
            )}
            {isLoadingGame === item.id && (
              <div className='absolute left-1/2 top-[20%] -translate-x-1/2'>
                <img
                  className='mx-auto'
                  src='/img/common/loading.svg'
                  alt='loading'
                />
              </div>
            )}
          </div>
        </div>
      </CardHoloEffect>
      <span className='text-14 ml-3 mt-1 line-clamp-1 select-none text-ellipsis font-normal text-black'>
        {item?.name}
      </span>
      <div
        className={clsx(
          'text-13 ml-3 line-clamp-1 h-fit min-h-[19.5px] text-ellipsis pb-1',
          'absolute right-1 top-1 z-10'
        )}
      >
        {number > 0 && (
          <div
            className='text-8 text-main-pri relative w-fit rounded-full border border-[0.5px] px-1 py-0.5 pr-1.5 font-bold'
            style={{
              background:
                'radial-gradient(143.73% 114.62% at 50.16% -7.95%, #D3A300 0%, #796843 0.01%, #2D2925 100%, #2D2925 100%)',
            }}
          >
            <CounterUp
              enableScrollSpy
              duration={3.5}
              startOnMount
              start={start}
              end={end}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemLive;
